var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6004C14.546 21.6004 16.9878 20.589 18.7881 18.7886C20.5885 16.9883 21.5999 14.5465 21.5999 12.0004C21.5999 9.45431 20.5885 7.01252 18.7881 5.21217C16.9878 3.41182 14.546 2.40039 11.9999 2.40039C9.45382 2.40039 7.01203 3.41182 5.21168 5.21217C3.41133 7.01252 2.3999 9.45431 2.3999 12.0004C2.3999 14.5465 3.41133 16.9883 5.21168 18.7886C7.01203 20.589 9.45382 21.6004 11.9999 21.6004ZM16.4483 10.4488C16.6669 10.2225 16.7878 9.91935 16.7851 9.60471C16.7824 9.29007 16.6562 8.9891 16.4337 8.76661C16.2112 8.54412 15.9102 8.41792 15.5956 8.41518C15.2809 8.41245 14.9778 8.5334 14.7515 8.75199L10.7999 12.7036L9.2483 11.152C9.02198 10.9334 8.71886 10.8124 8.40422 10.8152C8.08958 10.8179 7.78861 10.9441 7.56612 11.1666C7.34363 11.3891 7.21743 11.6901 7.21469 12.0047C7.21196 12.3193 7.33291 12.6225 7.5515 12.8488L9.9515 15.2488C10.1765 15.4738 10.4817 15.6001 10.7999 15.6001C11.1181 15.6001 11.4233 15.4738 11.6483 15.2488L16.4483 10.4488Z",
    fill: "#0E9F6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.8928815ef9aef0b8f5663a583686f6fe.svg";
export { ForwardRef as ReactComponent };